import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c6767f5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6767f5')) {
      api.createRecord('3c6767f5', component.options)
    } else {
      api.reload('3c6767f5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c6767f5", function () {
      api.rerender('3c6767f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/opt-event/table/index.vue"
export default component.exports